// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__azflb","closeButton":"Popover_closeButton__6s1Rt"};